export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.gongzuotai.yitihua': '一体化',
  'menu.gongzuotai.chuanganqi': '传感器',
  'menu.gongzuotai.chuanganqi.shuizhi': '水质传感器',
  'menu.gongzuotai.chuanganqi.shuiwen': '水文传感器',
  'menu.gongzuotai.chuanganqi.bengzha': '泵闸传感器',
  'menu.gongzuotai.shipingjiankong': '视频监控',
  'menu.gongzuotai.shipingjiankong.shipingjiankong': '视频监控',
  'menu.gongzuotai.shipingjiankong.chuanzaihuikan': '船载回看',
  'menu.gongzuotai.shipingjiankong.yidongzhongduan': '移动终端',
  'menu.gongzuotai.zhinengbengzha': '智能泵闸',
  'menu.gongzuotai.baojieyanghu': '作业轨迹',
  'menu.gongzuotai.ceshiguiji': '测试轨迹',
  'menu.gongzuotai': '数据展示',
  'menu.system': '系统管理',
  'menu.system.usermgmt': '用户管理',
  'menu.system.organize': '组织架构',
  'menu.system.pdamgmt': 'PDA管理',
  'menu.system.menuedit': '菜单管理',
  'menu.workportal': '工作台',
  'menu.workportal.hedaoyanghu': '河道养护',
  'menu.workportal.hedaojichushuju':'基础数据',
  'menu.workportal.yibiaoban':'仪表板',
  'menu.workportal.hedaoyanghu.jichushuju.hedaoshuju':'河道数据',
  'menu.workportal.hedaoyanghu.jichushuju.gongzuodizhi':'工作地址',
  'menu.workportal.hedaoyanghu.jichushuju.banzuxinxi':'班组信息',
  'menu.workportal.hedaoyanghu.jichushuju.gongzuoneirong':'工作内容',
  'menu.workportal.hedaoyanghu.jichushuju.anquanjiaodi':'安全交底',
  'menu.workportal.hedaoyanghu.jichushuju.zhuyishixiang':'注意事项',
  'menu.workportal.hedaoyanghu.yanghugongdan':'养护工单创建',
  'menu.workportal.hedaoyanghu.jichushuju':'基础数据',
  'menu.workportal.hedaoyanghu.gongzuorijiview':'工作日记查看', 
  'menu.workportal.hedaoyanghu.gongzuoliang':'工作量清单',
  'menu.workportal.hedaoyanghu.nianduqingdan':'工作量清单明细',
  'menu.workportal.hedaoyanghu.gongzuoriji':'新建保洁养护日记',
  'menu.workportal.hedaoyanghu.gongzuorijimgmt':'养护日记查询',
  'menu.workportal.hedaoyanghu.yanghugongdanbanjie':'养护工单办结',
  'menu.workportal.hedaoyanghu.gongzuorijichuli':'工作日记处理',
  'menu.workportal.hedaoyanghu.yanghugongdanchaxun':'保洁养护日记管理',
  'menu.workportal.hedaoyanghu.lvhuayanghugongdan':'绿化设施养护记录',
  'menu.workportal.hedaoyanghu.lvhuayanghugongdanchuli':'新建养护记录',
  'menu.workportal.hedaoyanghu.yanghujiluchakan':'养护记录查看',
  'menu.workportal.hedaoyanghu.baojieriji':'保洁养护日记下载',
  'menu.workportal.hedaoyanghu.sheshiriji':'绿化设施养护日记下载',
  'menu.workportal.hedaoyanghu.shuizhijiance':'水质检测记录',
  'menu.workportal.bengzhaguanli': '泵闸管理',
  'menu.workportal.bengzhaguanli.jichushuju': '基础数据',
  'menu.workportal.bengzhaguanli.bengzhayunxing': '泵闸运行',
  'menu.workportal.bengzhaguanli.bengzhayunxing.diaodupinlv': '调度频率记录',
  'menu.workportal.bengzhaguanli.bengzhayunxing.bengzhajiaobanjilu': '泵闸交班记录',
  'menu.workportal.bengzhaguanli.bengzhayunxing.bengzhakaiguan': '泵闸开关记录',
  'menu.workportal.bengzhaguanli.bengzhayanghu': '泵闸养护',
  'menu.workportal.bengzhaguanli.bengzhayanghu.beiyongfadianji': '备用发电机维保',
  'menu.workportal.bengzhaguanli.bengzhayanghu.diandonghulu': '电动葫芦行吊维保',
  'menu.workportal.bengzhaguanli.bengzhayanghu.yanghujilu': '泵闸养护记录',
  'menu.workportal.bengzhaguanli.bengzhaxunshi': '泵闸巡视',
  'menu.workportal.bengzhaguanli.bengzhaxunshi.shuishixuncha': '水事巡查',
  'menu.workportal.bengzhaguanli.jichushuju.bengzhaxinxi': '泵闸信息',
  'menu.workportal.bengzhaguanli.jichushuju.diandonghulu': '电动葫芦行吊信息',
  'menu.workportal.tifangxuncha': '堤防巡查',
  'menu.workportal.tifangxuncha.xunchajilu':'内河堤防巡查记录',
  'menu.workportal.tifangxuncha.difangxunchajilu':'内河巡查记录查询',
  'menu.workportal.tifangxuncha.waijiangxuncha':'外江堤防巡查记录',
  'menu.workportal.tifangxuncha.sheshixunchajilubiao':'堤防巡查设施类记录表',
  'menu.workportal.tifangxuncha.gongzuoshiji':'堤防巡查工作事迹',
  'menu.workportal.tifangxuncha.gongzuojianbao':'堤防巡查工作简报',
  'menu.workportal.tifangxuncha.huiyijiyao':'堤防巡查例会会议纪要',
   'menu.workportal.tifangxuncha.fangxunzhibanjilu':'防汛防台巡查值班记录',
    'menu.workportal.tifangxuncha.gongzuoqingkuanghuibao':'一周工作情况汇报',
    'menu.workportal.tifangxuncha.jiejiaridangban':'节假日当班表',
    'menu.workportal.tifangxuncha.richangxuncha':'日常巡查工作安排表',
  'menu.workportal.shijianguanli':'事件管理',
  'menu.workportal.shijianguanli.shijianchakan':'事件查看',
  'menu.oa':'OA办公',
  'menu.oa.jichushuju':'基础数据',
  'menu.oa.jichushuju.yuangongxinxisimple':'账号及权限',
  'menu.oa.jichushuju.yuangongxinxiall':'员工信息',
  'menu.oa.jichushuju.zuzhijiagou':'组织架构',
  'menu.oa.kaoqingguanli':'考勤管理',
  'menu.oa.kaoqingguanli.kaoqingshuju':'考勤数据查询',
  'menu.oa.kaoqingguanli.kaoqinshebei':'考勤设备清单',
  'menu.oa.wendangguanli':'文档管理',
  'menu.oa.wendangguanli.wendangguanli':'共享文件',
  'menu.oa.xinxifabu':'信息发布',
  'menu.oa.xinxifabu.fabuxinxi':'发布新通知',
  'menu.oa.xinxifabu.fabuguanli':'通知管理',
  'menu.oa.xinxifabu.xinxiliulan':'查看通知',
  'menu.oa.renwuguanli':'任务管理',
  'menu.oa.huiyiguanli':'会议管理',
  'menu.oa.xiangmuguanli':'项目管理',
  'menu.kucunguanli':'库存管理',
  'menu.kucunguanli.jichushuju':'基础数据',
  'menu.kucunguanli.jichushuju.danweiweihu':'计量单位',
  'menu.kucunguanli.jichushuju.wuliaoleixing':'物料类型',
  'menu.kucunguanli.jichushuju.kuweiguanli':'库位管理',
  'menu.kucunguanli.jichushuju.wuliaoguanli':'物料管理',
  'menu.kucunguanli.jichushuju.gongyingshangguanli':'供应商管理',
  'menu.kucunguanli.caigouruku':'采购入库',
  'menu.kucunguanli.kucunlishi':'库存历史数据',
  'menu.kucunguanli.wuliaoshenqing':'物料申请',
  'menu.kucunguanli.wuliaoshenqingshenpi':'物料申请审批',
  'menu.kucunguanli.lingyongchuku':'领用出库',
  'menu.kucunguanli.kucuntiaozheng':'库存调整',
  'menu.kucunguanli.kucunchaxun':'库存查询',
  'menu.shuzidangan':'数字档案',
  'menu.shuzidangan.shujuguidang':'数据归档',
  'menu.shuzidangan.danganshangchuan':'档案上传',
  'menu.shuzidangan.danganchaxun':'档案查询',
  'menu.zonghefengxi' : '综合分析',
  'menu.zonghefengxi.hedaoguanli' : '河道管理分析',
  'menu.zonghefengxi.shuihuanjing' : '水环境分析和预警',
  'menu.zonghefengxi.shuihuanjing.shuizhifenxi' : '水质分析',
  'menu.zonghefengxi.yunxingfengxi' : '运行分析和预警',
  'menu.AI' : 'AI知识库',
  'menu.AI.bendi' : '本地知识投喂',
  'menu.AI.zhuanjia' : '专家面对面',   
};
